<template>
	<v-card class="mt-3">
		<v-card-title>
			<h2>{{departmentName}}</h2>
		</v-card-title>
		<donation-contract-templates-list
			:possible-tags="possibleTags"
			:donation-contract-templates="donationContractTemplates"
			color="blue"
			header="Szablony kart umów dotacji"/>
	</v-card>
</template>

<script>
	import DonationContractTemplatesList from "./DonationContractTemplatesList";
	import {DonationContract} from "../../../api/generated/DonationContract";
	import {Department} from "../../../api/generated/Department";
	import {PossibleTagsDict} from "../../../utils/PossibleTagsDict";

	export default {
		name: "DonationContractTemplatesView",

		components: {DonationContractTemplatesList},

		methods: {
			refresh() {
				loadTemplates(this);
				loadDepartmentName(this);
			},

		},

		watch: {
			"$route.params": function () {
				this.refresh();
			},
		},

		data() {
			return {
				donationContractTemplates: [],
				departmentName: "",
				possibleTags: []
			};
		},

		created() {
			this.possibleTags = PossibleTagsDict.getDonationContractTags();
			this.refresh();
		},
	};

	function loadTemplates(ctx) {
		DonationContract.getList(ctx, ctx.$route.params.departmentId, successResponse => {
				ctx.donationContractTemplates = successResponse;
			},
			errorResponse => {
				ctx.$messagesBus.$emit("error", "Nie udało się załadować szablonów", errorResponse);
			});
	}

	function loadDepartmentName(ctx) {
		Department.getName(ctx, ctx.$route.params.departmentId, successResponse => {
				ctx.departmentName = successResponse.name;
			},
			errorResponse => {
				ctx.$messagesBus.$emit("error", "Nie udało się załadować nazwy departamentu", errorResponse);
			});
	}

</script>

<style scoped>
</style>
